import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SimpleButton from '../common/SimpleButton'
import PageModal from '../common/PageModal'
import { organizationRequestsWritePermission } from '../../utils/permissionValidation'
import { inviteBranch } from '../../actions/corporate'
import { InformationIcon } from '../../icons'
import './invite-branch-modal.scss'

const InviteBranchModal = (props) => {
  const { t } = useTranslation()
  const { closeModal, companyId, isLoading } = props
  const [email, setEmail] = useState('')

  const handleInvite = () => {
    const trimmedEmail = email.trim()
    props.actions.inviteBranch(companyId, { email:trimmedEmail, type: 'branch' }).then(() => {
      closeModal()
    })
  }

  const getFooter = () => {
    return (
      <>
        <SimpleButton className="cancel-button" onClick={closeModal}>
          {t('cancel')}
        </SimpleButton>
        <SimpleButton
          className="submit-button"
          onClick={handleInvite}
          disabled={!email || email.toLocaleLowerCase() === props.companyAdminEmail?.toLocaleLowerCase() || isLoading}
          requiredPermission={organizationRequestsWritePermission}
        >
          {t('add')}
        </SimpleButton>
      </>
    )
  }

  return (
    <PageModal toggle className="invite-branch-modal" onToggle={closeModal} title={t('organization_context.add_branch')} footerContent={getFooter()}>
      <div className="invite-branch-modal-content">
        <div className="row-wrapper">
          <div className="disclaimer">
            <div className="icon-wrapper">
              <InformationIcon />
            </div>
            <div className="content-wrapper">
              <p>{t('organization_context.invite_branch_disclaimer')}</p>
            </div>
          </div>
        </div>
        <div className="row-wrapper">
          <div className="input-wrapper">
            <p className="input-option">{t('email')}*</p>
            <input type="text" className="email-input" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
        </div>
      </div>
    </PageModal>
  )
}

function stateToProps({ authedUser, corporate }) {
  return {
    companyAdminEmail: authedUser?.email,
    isLoading: corporate?.isLoading,
  }
}

function dispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        inviteBranch,
      },
      dispatch,
    ),
  }
}

export default connect(stateToProps, dispatchToProps)(InviteBranchModal)

